import { pubPageAdTargeting } from "@config/AdsConstants";
import Advertisement from "@elements/Advertisement/Advertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";

type AdsLbProps = {
  sectionName: string;
  index?: number;
  pageAdTargetType: PageAdTargetValue;
  gsChannels?: string[];
  rootClassName?: string;
  rootStyle?: CSSProperties | undefined;
  articleSlotTarget?: ArticleAdSlotTargetingType[];
};
/**
 * Tabla LB1 Ad
 * Description: The adsLb1 component for rendering ads.
 * @name - name of section or page
 * @index - use when lb1 is rendered more than 1
 */
export function AdsLb1({
  sectionName,
  index,
  pageAdTargetType,
  gsChannels,
  articleSlotTarget,
}: AdsLbProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  if (sectionName === "/") {
    sectionName = "Home";
  }
  return (
    <div className="flex flex-col items-center justify-center max-w-full w-full lg:min-h-[150px] px-xxm lg:px-0 py-2.5 xmd:py-5">
      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.LB1,
          slot: GoogleAdsSlotFactory(AdvertisementTypeEnum.LB1, sectionName),
          id: index ? `dfp-ad-lb1-${index}` : "dfp-ad-lb1",
          rootClassName:
            "flex items-center [&_iframe]:max-w-screens-md sm:max-w-full",
          pubAdTargeting: [PubPageAdTarget],
          gsChannels,
          articleSlotTarget,
        }}
      />
    </div>
  );
}

/**
 * Tabla LB2 Ad
 * Description: The adsLb2 component for rendering ads.
 * @name - name of section or page
 * @index - use when lb2 is rendered more than 1
 */
export function AdsLb2({
  sectionName,
  index,
  pageAdTargetType,
  rootClassName,
  gsChannels,
  rootStyle,
}: AdsLbProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  if (sectionName === "/") {
    sectionName = "Home";
  }
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center max-w-full w-full lg:min-h-[150px] px-xxm lg:px-0 py-2.5 xmd:py-4",
        rootClassName,
      )}
      style={rootStyle}
    >
      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.LB2,
          slot: GoogleAdsSlotFactory(AdvertisementTypeEnum.LB2, sectionName),
          id: index ? `dfp-ad-lb2-${index}` : "dfp-ad-lb2",
          rootClassName:
            "flex items-center [&_iframe]:max-w-screens-md sm:max-w-full",
          pubAdTargeting: [PubPageAdTarget],
          gsChannels,
        }}
      />
    </div>
  );
}

/**
 * Tabla LB3 Ad
 * Description: The adsLb3 component for rendering ads.
 * @name - name of section or page
 * @index - use when lb3 is rendered more than 1
 */
export function AdsLb3({
  sectionName,
  index,
  pageAdTargetType,
  gsChannels,
  rootClassName,
  rootStyle,
}: AdsLbProps) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  if (sectionName === "/") {
    sectionName = "Home";
  }
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center max-w-full w-full lg:min-h-[150px] px-xxm lg:px-0 py-2.5 xmd:py-4",
        rootClassName,
      )}
      style={rootStyle}
    >
      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.LB3,
          slot: GoogleAdsSlotFactory(AdvertisementTypeEnum.LB3, sectionName),
          id: index ? `dfp-ad-lb3-${index}` : "dfp-ad-lb3",
          rootClassName:
            "flex items-center [&_iframe]:max-w-screens-md sm:max-w-full",
          pubAdTargeting: [PubPageAdTarget],
          gsChannels,
        }}
      />
    </div>
  );
}
